module.exports = __webpack_public_path__ + "img/02.d2e9f252.png";